module.exports = __webpack_public_path__ + "img/multiple-users-silhouette.8894086a.png";